export default {
    name: 'indication_history',
    definition: {
        module: '',
        valid_from: '',
        valid_until: '',
        is_chronic: '',
    },
};
